import React from "react";
import "jspdf-autotable";
import { useParams } from "react-router";
import {
  AuditTrailCareer,
  AuditTrailFilterCareer
} from "../../services/CareerLibraryServices";
import { RenderAuditTrailResourceType } from "../../utils/CommonGroupingItem";
import AuditTrailsTable from "../common/AuditTrailsTable";

function AuditTrail() {
  const { id } = useParams();

  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"];

  return (
    <AuditTrailsTable
      apiFunction={AuditTrailCareer}
      apiParams={{ action_id: id }}
      columnsToShow={columnsToShow}
      filterArrApi={AuditTrailFilterCareer}
      actionId={id}
      exportFileName={"Career Library Audit Trail"}
      isResourceNameShown={true}
      isShowingResourceTypeFilter
      renderResourceTypeFunction={RenderAuditTrailResourceType}
    />
  );
}

export default AuditTrail;
